import { Tabs, Flex } from "antd";
import TabAdminStaff from "./component/TabAdminStaff";
import TabAdvisors from "./component/TabAdvisors";
import TabClientsLeads from "./component/TabClientsLeads";

import StylesContainer from "./style";

import { getAllManagedUsersOfAdvisors } from "../../../../../../../../utils/helper/specialized";
import {
  isTypeLevelWealthEnterpriseAdmin,
  isTypeSuperAdmin,
  isPermissionReadonly,
} from "../../../../../super_admin/helper";
import { isWindowReadonly } from "../../../../../advisor/helper";

const SectionHome = ({
  defaultActiveKey,
  handleActionAdvisorEdit,
  handleActionAdvisorTransfer,
  handleActionClientArchive,
  handleActionClientTransfer,
  handleActionManagerArchive,
  handleButtonNewAdvisor,
  handleOpenManagedUser,
  handleProposalView,
  handleUserNameClick,
  isDisabledAdvisorResetPassword,
  loading,
  listCompanyUsers,
  listManagers,
  onTabChange,
  permissions,
}) => {
  const items = [
    {
      children: (
        <TabAdvisors
          disableEdit={
            isWindowReadonly() ||
            isPermissionReadonly(permissions?.manageAdvisors)
          }
          handleActionArchive={handleActionManagerArchive}
          handleActionEdit={handleActionAdvisorEdit}
          handleActionTransfer={handleActionAdvisorTransfer}
          handleButtonNewAdvisor={handleButtonNewAdvisor}
          handleOpenManagedUser={handleOpenManagedUser}
          handleUserNameClick={handleUserNameClick}
          isDisabledAdvisorResetPassword={isDisabledAdvisorResetPassword}
          listUsers={listCompanyUsers?.filter(
            it =>
              !isTypeLevelWealthEnterpriseAdmin(it.type) &&
              !isTypeSuperAdmin(it.type)
          )}
          loading={loading}
        />
      ),
      key: "advisors",
      label: (
        <Flex gap={8} style={{ lineHeight: "19px" }}>
          Advisors{" "}
          <div className="label-users-amount">
            {listCompanyUsers?.filter(
              it =>
                !isTypeLevelWealthEnterpriseAdmin(it.type) &&
                !isTypeSuperAdmin(it.type)
            )?.length ?? 0}
          </div>
        </Flex>
      ),
    },
    {
      children: (
        <TabClientsLeads
          disableEdit={isWindowReadonly()}
          handleActionClientArchive={handleActionClientArchive}
          handleActionClientTransfer={handleActionClientTransfer}
          handleProposalView={handleProposalView}
          handleUserNameClick={handleUserNameClick}
          listUsers={getAllManagedUsersOfAdvisors(listManagers)}
          loading={loading}
        />
      ),
      key: "clientsLeads",
      label: (
        <Flex gap={8} style={{ lineHeight: "19px" }}>
          Clients & Leads{" "}
          <div className="label-users-amount">
            {getAllManagedUsersOfAdvisors(listManagers)?.length ?? 0}
          </div>
        </Flex>
      ),
    },
    {
      children: (
        <TabAdminStaff
          disableEdit={
            isWindowReadonly() ||
            isPermissionReadonly(permissions?.manageEnterpriseAdmins)
          }
          handleActionEdit={handleActionAdvisorEdit}
          handleActionArchive={handleActionManagerArchive}
          handleUserNameClick={handleUserNameClick}
          listUsers={listCompanyUsers?.filter(it =>
            isTypeLevelWealthEnterpriseAdmin(it.type)
          )}
          loading={loading}
        />
      ),
      key: "adminStaff",
      label: (
        <Flex gap={8} style={{ lineHeight: "19px" }}>
          Admin & Staff{" "}
          <div className="label-users-amount">
            {listCompanyUsers?.filter(it =>
              isTypeLevelWealthEnterpriseAdmin(it.type)
            )?.length ?? 0}
          </div>
        </Flex>
      ),
    },
  ];

  return (
    <StylesContainer>
      <h3 style={{ margin: 0, padding: "16px 32px 40px" }}>People</h3>
      <Tabs
        defaultActiveKey={defaultActiveKey}
        items={items}
        onChange={onTabChange}
      />
    </StylesContainer>
  );
};

export default SectionHome;
